module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#listicle",
      toString: function () {
        return this.url;
      }
    }